// Skeleton de carga alineado con otros informes (p. ej. Logística): SectionBox + bg-hover-press
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

const CLIENT_ROWS = 6;

export const LoadingState = () => (
  <div className="px-6 pt-4 pb-10 space-y-6" data-testid="ready-to-prepare-loading">
    {/* Barra de filtros — mismo patrón que LogisticsSkeleton */}
    <div className="flex flex-col sm:flex-row sm:items-end gap-3 flex-wrap">
      <div className="space-y-1.5 min-w-[280px] flex-1">
        <Skeleton className="h-3 w-14 rounded-full bg-hover-press" />
        <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
      </div>
      <Skeleton className="h-10 w-full sm:w-28 shrink-0 rounded-md bg-hover-press" />
    </div>

    {/* Total por hora */}
    <SectionBox className="bg-card-bg">
      <div className="space-y-4">
        <div className="space-y-2 -mt-1">
          <Skeleton className="h-5 w-40 rounded-full bg-hover-press" />
          <Skeleton className="h-3 w-72 max-w-full rounded-full bg-hover-press" />
        </div>
        <Skeleton className="h-[300px] w-full rounded-md bg-hover-press" />
      </div>
    </SectionBox>

    {/* Pedidos por cliente y franja horaria */}
    <SectionBox className="bg-card-bg">
      <div className="space-y-4">
        <div className="space-y-2 -mt-1">
          <Skeleton className="h-5 w-64 rounded-full bg-hover-press" />
          <Skeleton className="h-3 w-full max-w-xl rounded-full bg-hover-press" />
        </div>
        <Skeleton className="h-10 w-full max-w-md rounded-md bg-hover-press" />
        <div className="space-y-3 pt-1">
          {Array.from({ length: CLIENT_ROWS }).map((_, i) => (
            <div
              key={i}
              className="grid grid-cols-1 gap-x-3 gap-y-2 min-[520px]:grid-cols-[minmax(12rem,22rem)_minmax(0,1fr)] min-[520px]:items-center min-[520px]:gap-y-0"
            >
              <Skeleton className="h-4 w-36 max-w-full rounded-full bg-hover-press" />
              <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
            </div>
          ))}
        </div>
      </div>
    </SectionBox>
  </div>
);
